import React from 'react';
import AccountContainer from '../../../../components/AccountContainer';
import subscriptionSideMenuItems from '../subscriptionSideMenuItems';
import Card from '../../../../components/Card';
import Loading from '../../../../components/Loading';
import Plan from './Plan';
import { useIntl } from 'react-intl';
import { useJsonApi } from '../../../../services/GlobalStore/GlobalStore';
import useAuthenticate from '../../../../hooks/useAuthenticate';

import messages from '../messages';

const MySubscription = () => {
  const { formatMessage } = useIntl();
  const { token } = useAuthenticate();

  const { data: subscription, loading: subscriptionLoading } = useJsonApi(
    `/subscriptions`,
    {
      cachePolicy: 'no-cache',
      queryParams: {
        include: ['currentSubscriptionBillingCycle'].join(),
      },
      headers: { Authorization: `Bearer ${token}` },
    },
    []
  );

  return (
    <AccountContainer menuItems={subscriptionSideMenuItems}>
      <Card style={cardStyles}>
        <span className="my-subscription-header">
          {formatMessage(messages.yourSubscriptionLabel)}
        </span>
        <br />
        {!subscriptionLoading ? (
          <Plan subscription={subscription?.[0]} />
        ) : (
          <div className="flex justify-center mt-40">
            <Loading />
          </div>
        )}
      </Card>
    </AccountContainer>
  );
};

export default MySubscription;

const cardStyles = {
  borderRadius: '12px',
  boxShadow: '0px 4px 8px 0px #D8D8DA',
};
